import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { request } from "@/utils/api";

/*// Async thunk for saving a pickup address
export const savePickupAddress = createAsyncThunk(
    "pickupAddress/save",
    async (
        { addressType, lines, city, state, pincode, landmark, isDefault, contactPerson, contactPhone, gstNumber },
        { rejectWithValue }
    ) => {
        try {
            // Call the API to save the pickup address
            const response = await request({
                endpoint: "/user/savePickupAddress",
                method: "POST",
                body: { addressType, lines, city, state, pincode, landmark, isDefault, contactPerson, contactPhone, gstNumber },
            });

            console.log("Save Pickup Address Response:", response);

            // Check if the save operation was successful
            if (!response || response.message !== "Pickup address saved successfully") {
                return rejectWithValue(response.message || "Failed to save pickup address.");
            }

            // Return the saved pickup address
            return response.data; // Assuming the response contains the saved address in `data`
        } catch (error) {
            console.error("Error saving pickup address:", error);
            return rejectWithValue(error.message || "An unexpected error occurred while saving the pickup address.");
        }
    }
);

// Async thunk for fetching pickup addresses
export const fetchPickupAddresses = createAsyncThunk(
    "pickupAddress/fetch",
    async (_, { rejectWithValue }) => {
        try {
            // Call the API to fetch pickup addresses
            const response = await request({
                endpoint: "/user/getPickupAddress", // Replace with your actual endpoint
                method: "GET",
            });

            console.log("Fetch Pickup Addresses Response:", response);

            // Check if the fetch operation was successful
            if (!response.address || !Array.isArray(response.address)) {
                return rejectWithValue(response.message || "Failed to fetch pickup addresses.");
            }

            // Return the fetched pickup addresses
            return response.address; // Assuming the response contains an array of addresses in `data`
        } catch (error) {
            console.error("Error fetching pickup addresses:", error);
            return rejectWithValue(error.message || "An unexpected error occurred while fetching pickup addresses.");
        }
    }
);*/

const initialState = {
    appData: null, // Array to store all pickup addresses
    loading: false,
    error: null,
};

const appSlice = createSlice({
    name: "app",
    initialState,
    reducers: {
        addAppData: (state, action) => {
            state.appData = action.payload;
        }
        ,
        clearAppData: (state) => {
            state.appData = [];
            state.loading = false;
            state.error = null;
        },
        updateCourier: (state, action) => {
            state.appData.courier = action.payload;
        },
        updateChannel: (state, action) => {
            state.appData.channels = action.payload;
        }
    },
    /* extraReducers: (builder) => {
         builder
             // Save Pickup Address
             .addCase(savePickupAddress.pending, (state) => {
                 state.loading = true;
                 state.error = null;
             })
             .addCase(savePickupAddress.fulfilled, (state, action) => {
                 state.loading = false;
                 state.pickupAddresses.push(action.payload); // Add the new address to the list
             })
             .addCase(savePickupAddress.rejected, (state, action) => {
                 state.loading = false;
                 state.error = action.payload; // Store the error message
             })
 
             // Fetch Pickup Addresses
             .addCase(fetchPickupAddresses.pending, (state) => {
                 state.loading = true;
                 state.error = null;
             })
             .addCase(fetchPickupAddresses.fulfilled, (state, action) => {
                 state.loading = false;
                 state.pickupAddresses = action.payload; // Update the pickup addresses array
             })
             .addCase(fetchPickupAddresses.rejected, (state, action) => {
                 state.loading = false;
                 state.error = action.payload; // Store the error message
             });
     },*/
});

export const { addAppData, clearAppData, updateCourier, updateChannel } = appSlice.actions;
export default appSlice.reducer;